export const dateFormat = 'DD.MM.YYYY';

export const dateFormatWithHour = 'DD.MM.YYYY HH:mm';
